import React, { useEffect, useState, useContext } from "react";
import {
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonItem,
  IonLabel,
  IonButton,
  IonInput,
  IonText,
  IonSpinner,
} from "@ionic/react";
import { baseurl, clientID } from "../../util/config";
import { getUserInfo } from "../../service/adminUI";
import SessionManager from "../../service/SessionManager";
import PHIMask from "../../components/PHIMask";
import AppContext from "../../components/AppContext";

const Profile = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { userData } = useContext(AppContext);

  useEffect(() => {
    const loadUserInfo = async () => {
      try {
        const token = SessionManager.getAccessToken();
        if (!token) {
          setError("Session expired. Please log in again.");
          setLoading(false);
          return;
        }
        const info = await getUserInfo(token);
        setUserInfo(info);
      } catch (e) {
        setError("Unable to load profile information.");
      } finally {
        setLoading(false);
      }
    };

    loadUserInfo();
  }, []);

  const handleChangePassword = () => {
    // Use Keycloak Application Initiated Action (AIA) to update password
    const redirectUri = window.location.origin + "/dashboard/home";
    const authUrl =
      baseurl + "auth/realms/calyan/protocol/openid-connect/auth";

    const params = new URLSearchParams({
      response_type: "code",
      client_id: clientID,
      redirect_uri: redirectUri,
      kc_action: "UPDATE_PASSWORD",
    });

    window.location.href = `${authUrl}?${params.toString()}`;
  };

  return (
    <IonGrid style={{ padding: "24px" }}>
      <IonRow>
        <IonCol size="12" sizeMd="8" offsetMd="2">
          <IonCard>
            <IonCardHeader>
              <IonCardTitle 
                style={{ 
                  fontWeight: "bold", 
                  backgroundColor: "#545453", 
                  color: "#ffffff",
                  padding: "10px 10px",
                  borderRadius: "2px",
                  margin: "0"
                }}
              >
                Profile
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
                  {loading && (
                    <div style={{ textAlign: "center", padding: "16px" }}>
                      <IonSpinner name="crescent" />
                    </div>
                  )}

                  {!loading && error && (
                    <IonText color="danger">
                      <p>{error}</p>
                    </IonText>
                  )}

                  {!loading && !error && userInfo && (
                    <>
                      <IonItem lines="none">
                        <IonLabel position="stacked">Name</IonLabel>
                        <IonInput
                          value={`${userInfo.firstName || ""} ${
                            userInfo.lastName || ""
                          }`.trim()}
                          readonly
                        />
                      </IonItem>

                      <IonItem lines="none">
                        <IonLabel position="stacked">Email</IonLabel>
                        <div
                          data-testid="TPROFILE_EMAIL"
                          style={{ 
                          width: '100%', 
                          padding: '8px 0',
                          display: 'flex',
                          alignItems: 'center'
                        }}>
                          <PHIMask
                            value={userInfo.email || ""}
                            fieldType="email"
                            patientId={null}
                            userId={userData?.userId || null}
                            authorized={true}
                            style={{
                              fontSize: '16px',
                              color: '#333',
                              flex: 1
                            }}
                          />
                        </div>
                      </IonItem>

                      <IonItem lines="none">
                        <IonLabel position="stacked">Username</IonLabel>
                        <div
                          data-testid="TPROFILE_USERNAME"
                          style={{ 
                          width: '100%', 
                          padding: '8px 0',
                          display: 'flex',
                          alignItems: 'center'
                        }}>
                          <PHIMask
                            value={userInfo.username || ""}
                            fieldType="username"
                            patientId={null}
                            userId={userData?.userId || null}
                            authorized={true}
                            style={{
                              fontSize: '16px',
                              color: '#333',
                              flex: 1
                            }}
                          />
                        </div>
                      </IonItem>
                    </>
                  )}

                  {/* Always show change password section so page is not blank */}
                  {!loading && (
                    <div style={{ marginTop: "24px" }}>
                      <IonText>
                        <h2 style={{ marginBottom: "8px" }}>Change Password</h2>
                        <p style={{ fontSize: "0.9rem", color: "#666" }}>
                          You will be redirected to the secure Keycloak account
                          page to update your password. After changing it, you
                          will return to this application.
                        </p>
                      </IonText>

                      <IonButton
                        expand="block"
                        style={{ marginTop: "16px" }}
                        onClick={handleChangePassword}
                        data-testid="TPROFILE_CHANGEPASSWORD"
                      >
                        Change Password
                      </IonButton>
                    </div>
                  )}
            </IonCardContent>
          </IonCard>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default Profile;


